import { callGetApi, callPostApi, callPutApi, callDeleteApi } from '../apiCallerProxy';
import { createApiHook } from '../hooks';
import { campaignGroupApiFactory } from './campaignGroupApiFactory';

export const campaignGroupApi = campaignGroupApiFactory({ callGetApi, callPostApi, callPutApi, callDeleteApi });
export const useCampaignGroupApi = createApiHook(campaignGroupApiFactory);
